import { render, staticRenderFns } from "./IUpload.vue?vue&type=template&id=5d0d77a0&"
import script from "./IUpload.vue?vue&type=script&lang=ts&"
export * from "./IUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports